import colors from '../tokens/colors';

export const formLabelGetolo = {
  typography: 'h3',
  color: colors.PROFESSIONAL_BLUE,
  requiredIndicatorColor: colors.PROFESSIONAL_BLUE,
};

export const formLabelDaDirekt = {
  typography: 'h3',
  color: colors.PROFESSIONAL_BLUE,
  requiredIndicatorColor: colors.PROFESSIONAL_BLUE,
};

export const formLabelDaKaufland = {
  typography: 'h4',
  color: colors.DA_KAUFLAND_BLACK,
  requiredIndicatorColor: colors.DA_KAUFLAND_BLACK,
};

export const formLabelFressnapf = {
  typography: 'h3',
  color: colors.FRESSNAPF_TEXT_PRIMARY,
  requiredIndicatorColor: colors.FRESSNAPF_TEXT_PRIMARY,
};
